import { SpamTokenChain } from 'api/types/spamTokenApiTypes'
import AnchorageLogo from 'assets/add-sources-logos/anchorage.svg?react'
import ArbitrumNovaLogo from 'assets/add-sources-logos/arbitrum-nova.svg?react'
import ArbitrumLogo from 'assets/add-sources-logos/arbitrum.svg?react'
import AvalancheLogo from 'assets/add-sources-logos/avalanche.svg?react'
import BaseLogo from 'assets/add-sources-logos/base.svg?react'
import BinanceSmartChainLogo from 'assets/add-sources-logos/binance-smart-chain.svg?react'
import BitGoLogo from 'assets/add-sources-logos/bit-go.svg?react'
import BitcoinCashLogo from 'assets/add-sources-logos/bitcoin-cash.svg?react'
import BitcoinLogo from 'assets/add-sources-logos/bitcoin.svg?react'
import BitfinexLogo from 'assets/add-sources-logos/bitfinex.svg?react'
import CantoLogo from 'assets/add-sources-logos/canto.svg?react'
import CardanoLogo from 'assets/add-sources-logos/cardano.svg?react'
import CircleLogo from 'assets/add-sources-logos/circle.svg?react'
import CoinbaseExchangeLogo from 'assets/add-sources-logos/coinbase-exchange.svg?react'
import CoinbasePrimeLogo from 'assets/add-sources-logos/coinbase-prime.svg?react'
import CoinbaseLogo from 'assets/add-sources-logos/coinbase.svg?react'
import CsvLogo from 'assets/add-sources-logos/csv.svg?react'
import DashLogo from 'assets/add-sources-logos/dash.svg?react'
import DogecoinLogo from 'assets/add-sources-logos/doge-coin.svg?react'
import EthereumLogo from 'assets/add-sources-logos/ethereum.svg?react'
import FireblocksLogo from 'assets/add-sources-logos/fireblocks.svg?react'
import FoundryLogo from 'assets/add-sources-logos/foundry.svg?react'
import GeminiLogo from 'assets/add-sources-logos/gemini.svg?react'
import KrakenLogo from 'assets/add-sources-logos/kraken.svg?react'
import KuCoinLogo from 'assets/add-sources-logos/kucoin.svg?react'
import LitecoinLogo from 'assets/add-sources-logos/litecoin.svg?react'
import NearLogo from 'assets/add-sources-logos/near.svg?react'
import OptimismLogo from 'assets/add-sources-logos/optimism.svg?react'
import PolygonLogo from 'assets/add-sources-logos/polygon.svg?react'
import ProtonLogo from 'assets/add-sources-logos/proton.svg?react'
import RippleCustodyLogo from 'assets/add-sources-logos/ripple.svg?react'
import RootstockLogo from 'assets/add-sources-logos/rootstock.svg?react'
import SolanaLogo from 'assets/add-sources-logos/solana.svg?react'
import Syonata from 'assets/add-sources-logos/synota.svg?react'
import TronLogo from 'assets/add-sources-logos/tron.svg?react'
import VoltageLogo from 'assets/add-sources-logos/voltage.svg?react'
import { QueryKey } from 'hooks/data/queryKeys'
import { isZeusEnvironment } from 'utils/environment'

import DataSource, { isDataSource } from './DataSource'

export const DATASOURCE_TO_DISPLAY_NAME: Record<DataSource | SpamTokenChain, string> = {
  [DataSource.AnchorageIaaS]: 'Anchorage',
  [DataSource.Arbitrum]: 'Arbitrum',
  [DataSource.ArbitrumNova]: 'Arbitrum Nova',
  [DataSource.Avalanche]: 'Avalanche',
  [DataSource.Base]: 'Base',
  [DataSource.BinanceSmartChain]: 'BNB Chain',
  [DataSource.Bitcoin]: 'Bitcoin',
  [DataSource.BitcoinCash]: 'Bitcoin Cash',
  [DataSource.BitcoinIaaS]: 'Bitcoin',
  [DataSource.Bitfinex]: 'Bitfinex',
  [DataSource.BitGo]: 'BitGo',
  [DataSource.Canto]: 'Canto',
  [DataSource.Cardano]: 'Cardano',
  [DataSource.Circle]: 'Circle',
  [DataSource.CoinbaseIaaS]: 'Coinbase',
  [DataSource.CoinbaseExchangeIaaS]: 'Coinbase Exchange',
  [DataSource.CoinbasePrimeIaaS]: 'Coinbase Prime',
  [DataSource.CsvImport]: 'Generic CSV',
  [DataSource.Dash]: 'Dash',
  [DataSource.Dogecoin]: 'Dogecoin',
  [DataSource.EthereumIaaS]: 'Ethereum',
  [DataSource.Fireblocks]: 'Fireblocks',
  [DataSource.Foundry]: 'Foundry',
  [DataSource.GeminiIaaS]: 'Gemini',
  [DataSource.Kraken]: 'Kraken',
  [DataSource.KuCoin]: 'KuCoin',
  [DataSource.Litecoin]: 'Litecoin',
  [DataSource.Near]: 'Near',
  [DataSource.Optimism]: 'Optimism',
  [DataSource.PolygonIaaS]: 'Polygon',
  [DataSource.Proton]: 'XPR Network',
  [DataSource.RippleCustody]: 'Ripple Custody',
  [DataSource.Rootstock]: 'Rootstock',
  [DataSource.SolanaNew]: 'Solana (New)',
  [DataSource.SolanaIaaS]: 'Solana',
  [DataSource.Synota]: 'Synota',
  [DataSource.Voltage]: 'Voltage',
  [DataSource.Ethereum]: 'Ethereum',
  [DataSource.Polygon]: 'Polygon',
  [DataSource.Solana]: 'Solana',
  [DataSource.Tron]: 'Tron',
} as const

export function getDataSourceDisplayName(dataSource: string | DataSource): string {
  if (isDataSource(dataSource)) {
    return DATASOURCE_TO_DISPLAY_NAME[dataSource]
  }
  return dataSource
}

export const DISPLAY_NAME_TO_DATASOURCE: Record<string, string> = Object.entries(
  DATASOURCE_TO_DISPLAY_NAME
).reduce<Record<string, string>>((acc, [key, value]) => {
  acc[value] = key
  return acc
}, {})

export const DATASOURCE_TO_LOGO_COMPONENT: Record<DataSource, React.ComponentType> = {
  [DataSource.AnchorageIaaS]: AnchorageLogo,
  [DataSource.Arbitrum]: ArbitrumLogo,
  [DataSource.ArbitrumNova]: ArbitrumNovaLogo,
  [DataSource.Avalanche]: AvalancheLogo,
  [DataSource.Base]: BaseLogo,
  [DataSource.BinanceSmartChain]: BinanceSmartChainLogo,
  [DataSource.Bitcoin]: BitcoinLogo,
  [DataSource.BitcoinCash]: BitcoinCashLogo,
  [DataSource.BitcoinIaaS]: BitcoinLogo,
  [DataSource.Bitfinex]: BitfinexLogo,
  [DataSource.BitGo]: BitGoLogo,
  [DataSource.Canto]: CantoLogo,
  [DataSource.Cardano]: CardanoLogo,
  [DataSource.Circle]: CircleLogo,
  [DataSource.CoinbaseIaaS]: CoinbaseLogo,
  [DataSource.CoinbaseExchangeIaaS]: CoinbaseExchangeLogo,
  [DataSource.CoinbasePrimeIaaS]: CoinbasePrimeLogo,
  [DataSource.CsvImport]: CsvLogo,
  [DataSource.Dash]: DashLogo,
  [DataSource.Dogecoin]: DogecoinLogo,
  [DataSource.EthereumIaaS]: EthereumLogo,
  [DataSource.Fireblocks]: FireblocksLogo,
  [DataSource.Foundry]: FoundryLogo,
  [DataSource.GeminiIaaS]: GeminiLogo,
  [DataSource.Kraken]: KrakenLogo,
  [DataSource.KuCoin]: KuCoinLogo,
  [DataSource.Litecoin]: LitecoinLogo,
  [DataSource.Near]: NearLogo,
  [DataSource.Optimism]: OptimismLogo,
  [DataSource.PolygonIaaS]: PolygonLogo,
  [DataSource.Proton]: ProtonLogo,
  [DataSource.RippleCustody]: RippleCustodyLogo,
  [DataSource.Rootstock]: RootstockLogo,
  [DataSource.SolanaNew]: SolanaLogo,
  [DataSource.SolanaIaaS]: SolanaLogo,
  [DataSource.Synota]: Syonata,
  [DataSource.Voltage]: VoltageLogo,
  [DataSource.Ethereum]: EthereumLogo,
  [DataSource.Polygon]: PolygonLogo,
  [DataSource.Solana]: SolanaLogo,
  [DataSource.Tron]: TronLogo,
} as const

export const DATASOURCE_TO_QUERY_KEY: Partial<Record<DataSource, string>> = {
  [DataSource.AnchorageIaaS]: QueryKey.AnchorageIaasDate,
  [DataSource.Arbitrum]: QueryKey.ArbitrumDate,
  [DataSource.ArbitrumNova]: QueryKey.ArbitrumNovaDate,
  [DataSource.Avalanche]: QueryKey.AvalancheDate,
  [DataSource.Base]: QueryKey.BaseDate,
  [DataSource.BinanceSmartChain]: QueryKey.BinanceSmartChainDate,
  [DataSource.Bitcoin]: QueryKey.BitcoinDate,
  [DataSource.BitcoinCash]: QueryKey.BitcoinCashDate,
  [DataSource.BitcoinIaaS]: QueryKey.BitcoinDate,
  [DataSource.Bitfinex]: QueryKey.BitfinexDate,
  [DataSource.BitGo]: QueryKey.BitgoDate,
  [DataSource.Canto]: QueryKey.CantoDate,
  [DataSource.Cardano]: QueryKey.CardanoDate,
  [DataSource.Circle]: QueryKey.CircleDate,
  [DataSource.CoinbaseIaaS]: QueryKey.CoinbaseIaas,
  [DataSource.CoinbaseExchangeIaaS]: QueryKey.CoinbaseExchangeIaas,
  [DataSource.CoinbasePrimeIaaS]: QueryKey.CoinbasePrimeIaas,
  [DataSource.Dash]: QueryKey.DashDate,
  [DataSource.Dogecoin]: QueryKey.DogeDate,
  [DataSource.EthereumIaaS]: QueryKey.EthereumDate,
  [DataSource.Fireblocks]: QueryKey.FireblocksDate,
  [DataSource.Foundry]: QueryKey.FoundryDate,
  [DataSource.GeminiIaaS]: QueryKey.GeminiIaas,
  [DataSource.Kraken]: QueryKey.KrakenDate,
  [DataSource.KuCoin]: QueryKey.KuCoinDate,
  [DataSource.Litecoin]: QueryKey.LitecoinDate,
  [DataSource.Near]: QueryKey.NearDate,
  [DataSource.Optimism]: QueryKey.OptimismDate,
  [DataSource.Proton]: QueryKey.ProtonDate,
  [DataSource.PolygonIaaS]: QueryKey.PolygonDate,
  [DataSource.RippleCustody]: QueryKey.RippleCustodyDate,
  [DataSource.Rootstock]: QueryKey.RootstockDate,
  [DataSource.SolanaNew]: QueryKey.SolanaNewDate,
  [DataSource.SolanaIaaS]: QueryKey.SolanaDate,
  [DataSource.Synota]: QueryKey.SynotaDate,
  [DataSource.Voltage]: QueryKey.VoltageDate,
  [DataSource.Tron]: QueryKey.TronDate,
} as const

export const DATASOURCE_TO_STATUS_QUERY_KEY: Partial<Record<DataSource, string>> = {
  [DataSource.AnchorageIaaS]: QueryKey.AnchorageIaasStatus,
  [DataSource.Arbitrum]: QueryKey.ArbitrumStatus,
  [DataSource.ArbitrumNova]: QueryKey.ArbitrumNovaStatus,
  [DataSource.Avalanche]: QueryKey.AvalancheStatus,
  [DataSource.Base]: QueryKey.BaseStatus,
  [DataSource.BinanceSmartChain]: QueryKey.BinanceSmartChainStatus,
  [DataSource.Bitcoin]: QueryKey.BitcoinStatus,
  [DataSource.BitcoinCash]: QueryKey.BitcoinCashStatus,
  [DataSource.BitcoinIaaS]: QueryKey.BitcoinStatus,
  [DataSource.Bitfinex]: QueryKey.BitfinexStatus,
  [DataSource.BitGo]: QueryKey.BitgoStatus,
  [DataSource.Canto]: QueryKey.CantoStatus,
  [DataSource.Cardano]: QueryKey.CardanoStatus,
  [DataSource.Circle]: QueryKey.CircleStatus,
  [DataSource.CoinbaseIaaS]: QueryKey.CoinbaseIaasStatus,
  [DataSource.CoinbaseExchangeIaaS]: QueryKey.CoinbaseExchangeIaasStatus,
  [DataSource.CoinbasePrimeIaaS]: QueryKey.CoinbasePrimeIaasStatus,
  [DataSource.Dash]: QueryKey.DashStatus,
  [DataSource.Dogecoin]: QueryKey.DogeStatus,
  [DataSource.EthereumIaaS]: QueryKey.EthereumStatus,
  [DataSource.Fireblocks]: QueryKey.FireblocksStatus,
  [DataSource.Foundry]: QueryKey.FoundryStatus,
  [DataSource.GeminiIaaS]: QueryKey.GeminiIaasStatus,
  [DataSource.Kraken]: QueryKey.KrakenStatus,
  [DataSource.KuCoin]: QueryKey.KuCoinStatus,
  [DataSource.Litecoin]: QueryKey.LitecoinStatus,
  [DataSource.Near]: QueryKey.NearStatus,
  [DataSource.Optimism]: QueryKey.OptimismStatus,
  [DataSource.Proton]: QueryKey.ProtonStatus,
  [DataSource.PolygonIaaS]: QueryKey.PolygonStatus,
  [DataSource.RippleCustody]: QueryKey.RippleCustodyStatus,
  [DataSource.Rootstock]: QueryKey.RootstockStatus,
  [DataSource.SolanaNew]: QueryKey.SolanaNewStatus,
  [DataSource.SolanaIaaS]: QueryKey.SolanaStatus,
  [DataSource.Synota]: QueryKey.SynotaStatus,
  [DataSource.Voltage]: QueryKey.VoltageStatus,
  [DataSource.Tron]: QueryKey.TronStatus,
}

export const ALL_SOURCES = Object.values(DataSource)

export const EXCHANGES = [
  DataSource.AnchorageIaaS,
  DataSource.Bitfinex,
  DataSource.BitGo,
  DataSource.Circle,
  DataSource.CoinbaseIaaS,
  DataSource.CoinbaseExchangeIaaS,
  DataSource.CoinbasePrimeIaaS,
  DataSource.Fireblocks,
  DataSource.Foundry,
  DataSource.GeminiIaaS,
  DataSource.Kraken,
  DataSource.KuCoin,
  DataSource.RippleCustody,
  DataSource.Synota,
  DataSource.Voltage,
] as const

export const NON_CHAIN_SOURCES = [...EXCHANGES, DataSource.CsvImport]

// No longer offered anywhere a source can be added; existing sources still display.
export const RETIRED_SOURCES: DataSource[] = [DataSource.Canto]

export const CHAIN_SOURCES = ALL_SOURCES.filter((source) => !NON_CHAIN_SOURCES.includes(source))

export const IAAS_SOURCES = [
  DataSource.AnchorageIaaS,
  DataSource.Arbitrum,
  DataSource.ArbitrumNova,
  DataSource.Avalanche,
  DataSource.Base,
  DataSource.BinanceSmartChain,
  DataSource.BitcoinCash,
  DataSource.BitcoinIaaS,
  DataSource.Bitfinex,
  DataSource.BitGo,
  DataSource.Cardano,
  DataSource.CoinbaseIaaS,
  DataSource.CoinbaseExchangeIaaS,
  DataSource.CoinbasePrimeIaaS,
  DataSource.Dash,
  DataSource.Dogecoin,
  DataSource.EthereumIaaS,
  DataSource.Circle,
  DataSource.Fireblocks,
  DataSource.Foundry,
  DataSource.GeminiIaaS,
  DataSource.Kraken,
  DataSource.KuCoin,
  DataSource.Litecoin,
  DataSource.Near,
  DataSource.Optimism,
  DataSource.Proton,
  DataSource.PolygonIaaS,
  DataSource.RippleCustody,
  DataSource.Rootstock,
  DataSource.SolanaNew,
  DataSource.SolanaIaaS,
  DataSource.Tron,
  DataSource.Voltage,
  DataSource.Synota,
]

export const CHAIN_IAAS_SOURCES: SpamTokenChain[] = [
  DataSource.EthereumIaaS,
  DataSource.PolygonIaaS,
  DataSource.SolanaIaaS,
  DataSource.BitcoinCash,
  DataSource.BitcoinIaaS,
  DataSource.Optimism,
  DataSource.Arbitrum,
  DataSource.ArbitrumNova,
  DataSource.Avalanche,
  DataSource.BinanceSmartChain,
  DataSource.Dash,
  DataSource.Dogecoin,
  DataSource.Near,
  DataSource.Litecoin,
  DataSource.Proton,
  DataSource.Base,
  DataSource.Cardano,
  DataSource.Rootstock,
  DataSource.SolanaNew,
  DataSource.Tron,
]

export const CHAIN_ZEUS_SOURCES = [
  DataSource.Arbitrum,
  DataSource.ArbitrumNova,
  DataSource.Avalanche,
  DataSource.Base,
  DataSource.BinanceSmartChain,
  DataSource.Bitcoin,
  DataSource.BitcoinCash,
  DataSource.Cardano,
  DataSource.Dash,
  DataSource.Dogecoin,
  DataSource.Ethereum,
  DataSource.Litecoin,
  DataSource.Near,
  DataSource.Optimism,
  DataSource.Polygon,
  DataSource.Proton,
  DataSource.Rootstock,
  DataSource.Solana,
  DataSource.Tron,
]

/* This is a mapping of aliases to the actual data source.
 * This is only needed because during the migration of sources from {source} -> {source'IaaS'}
 * During the migration, only production was migrated on the backend. Staging was not.
 * So until staging is migrated, these "Aliases" allow us to map the aliases to the actual data source.
 */
export const DATA_SOURCE_ALIASES: Record<string, DataSource> = {
  Ethereum: DataSource.EthereumIaaS,
  Polygon: DataSource.PolygonIaaS,
  Solana: DataSource.SolanaIaaS,
  Bitcoin: isZeusEnvironment() ? DataSource.Bitcoin : DataSource.BitcoinIaaS,
  Gemini: DataSource.GeminiIaaS,
  CoinbaseExchange: DataSource.CoinbaseExchangeIaaS,
  CoinbasePrime: DataSource.CoinbasePrimeIaaS,
}

export const getDataSourceByName = (dataSource: string): DataSource | undefined => {
  if (isDataSource(dataSource)) {
    return dataSource
  }

  if (Object.keys(DATA_SOURCE_ALIASES).includes(dataSource)) {
    return DATA_SOURCE_ALIASES[dataSource]
  }

  return undefined
}

export function isExchange(value: string): value is (typeof EXCHANGES)[number] {
  return EXCHANGES.includes(value as (typeof EXCHANGES)[number])
}
